<template>
  <div class="summary-position">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据源下载次数TOP10</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-card class="page-card">
          <div id="summary-target-top"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
  
<script>
import axios from 'axios';
import * as echarts from 'echarts';

export default {
  name: 'SummaryPositionData',
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      axios.post('/iapi/getsummytargettop').then((res) => {
        if (res.data.errcode === 0) {
          this.initEcharts(res.data.data);
        }
      });
    },
    initEcharts(data) {
      const myChart = echarts.init(document.getElementById('summary-target-top'));
      const option = {
        title: {
          text: 'TOP10源下载次数',
        },
        grid: {
          bottom: 120,
        },
        xAxis: {
          type: 'category',
          data: data.map((item) => {
            return item.target;
          }),
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: data.map((item) => {
              return item.download_times;
            }),
            type: 'bar',
            barWidth: 36,
            itemStyle: {
                color: '#0066B8'
            }
          }
        ]
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped>
#summary-target-top {
  height: 600px;
}
.summary-position {
  padding: 24px 56px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>
